import * as React from 'react'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Table, Row, Col, Icon } from 'antd'
import { ComponentExt } from '@utils/reactExt'
import { TimeFormat } from '@utils/index'
import * as styles from './index.scss'

type ListProps = RouteComponentProps<any> & {
    notifications?: any
    filters?: {
        read?: number
        type?: string
        startDate?: string
        endDate?: string
        clientSearch?: string
    }
}

@inject((store: any) => {
    const { notifications } = store

    return {
        notifications
    }
})
@observer
class NotificationsList extends ComponentExt<ListProps, any> {
    handleTableChange = e => {
        this.props.notifications.getNotifications({ pageIndex: e.current })
    }
    componentDidMount() {
        this.props.notifications.updateFilters(this.props.filters ? this.props.filters : {})
        this.props.notifications.getNotifications({ pageIndex: 1 })
    }
    render() {
        const { list, pageIndex, totalCount, loading } = this.props.notifications

        const columns = [
            {
                key: 'type_icon',
                render: (_, record) => {
                    const icon = record.type === 'UPDATE' ? <Icon type="warning" /> : <Icon type="user" />
                    return icon
                }
            },
            {
                title: 'לקוח',
                key: 'client_name',
                render: (_, record) => {
                    return <span>{record.assignedCustomer.name}</span>
                }
            },
            {
                title: 'נושא',
                key: 'notification_subject',
                render: (_, record) => {
                    return <span>{record.subject}</span>
                }
            },
            {
                title: 'תאריך',
                key: 'date',
                render: (_, record) => <span>{TimeFormat(record.date)}</span>
            },
            {
                title: 'קישור',
                key: 'go_to',
                render: (_, record) => {
                    const link =
                        record.type === 'ALERT' ? (
                            <Link to={`/customers/info/${record.targetId}`}>צפה בפרטי לקוח</Link>
                        ) : (
                            <Link to={`/inquiries/${record.targetId}`}>צפה בפניה</Link>
                        )
                    return link
                }
            }
        ]

        return (
            <Row>
                <Col>
                    <div className="box">
                        <Table
                            className="center-table"
                            style={{ width: '100%' }}
                            rowKey="id"
                            loading={loading}
                            rowClassName={record => (record.reader ? styles.read : styles.unread)}
                            columns={columns}
                            dataSource={list}
                            pagination={{
                                total: totalCount,
                                pageSize: 10,
                                current: pageIndex
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        const target =
                                            record.type === 'ALERT'
                                                ? `/customers/info/${record.targetId}`
                                                : `/inquiries/${record.targetId}`

                                        this.api.notificationService.updateNotification(record.id)
                                        this.props.history.push(target)
                                    }
                                }
                            }}
                            onChange={this.handleTableChange}
                        />
                    </div>
                </Col>
            </Row>
        )
    }
}

export default withRouter(NotificationsList)
